import { Switch } from "@headlessui/react";
import { Formik, Form } from "formik";
import _ from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ButtonLoader from "@/Components/ButtonLoader";
import {
  updatePermissions,
  updateEditActiveStep,
  editRoleAccessdata,
} from "@/reducers/client_user/roleAccess";
import { allPermissionsData } from "@/utilities/defaultData";

import { routingConstants } from "../../../../../../Constants/routingConstants";

const EditFeatureAccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { roleAccessData } = useSelector((state) => state.clientRoles);
  const { allPermission } = roleAccessData;

  const filteredPermissions = allPermissionsData.filter(
    (ele) => ele.type === "feature",
  );

  const keysArr = _.map(filteredPermissions, "value");
  const isAllSelected = keysArr.every((key) => allPermission[key]);

  const handleToggleAll = () => {
    const updatedPermissions = filteredPermissions.reduce((acc, perm) => {
      acc[perm.value] = !isAllSelected;
      return acc;
    }, {});
    dispatch(updatePermissions(updatedPermissions));
  };

  const handleTogglePermission = (key) => {
    dispatch(updatePermissions({ [key]: !allPermission[key] }));
  };

  const handleFormSubmit = (setSubmitting) => {
    const callback = () => navigate(routingConstants.clientRole);
    dispatch(editRoleAccessdata({ setSubmitting, callback }));
  };

  return (
    <div className="JobDetails_Wrapper mb-14 grid gap-4">
      <div className="rounded-lg bg-white p-6">
        <Formik
          initialValues={{}}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) =>
            handleFormSubmit(setSubmitting)
          }
        >
          {({ submitForm, isSubmitting, isValid }) => (
            <Form>
              <div className="mb-4 flex justify-between">
                <h4 className="text-[18px] font-medium text-black">
                  Feature Access
                </h4>
                <button
                  type="button"
                  className="h-[40px] w-[120px] cursor-pointer rounded-lg border border-primary bg-white text-[14px] font-medium text-primary transition-all duration-200 hover:bg-primary hover:text-white"
                  onClick={handleToggleAll}
                >
                  {isAllSelected ? "Deselect All" : "Select All"}
                </button>
              </div>

              <div className="grid grid-cols-1 gap-[40px] sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4">
                {filteredPermissions.map((perm) => (
                  <div
                    key={perm.value}
                    className="flex select-none items-center gap-[12px]"
                  >
                    <Switch
                      checked={!!allPermission[perm.value]}
                      onChange={() => handleTogglePermission(perm.value)}
                      className={`group inline-flex min-h-[1.79rem] min-w-[3.2rem] items-center rounded-full shadow-sm transition-colors duration-200 ${
                        allPermission[perm.value]
                          ? "bg-primary"
                          : "bg-[#dddddd]"
                      }`}
                    >
                      <span
                        className={`inline-block h-[22px] w-[22px] transform rounded-full bg-white shadow-md transition-transform duration-200 ${
                          allPermission[perm.value]
                            ? "translate-x-[25px]"
                            : "translate-x-1"
                        }`}
                      />
                    </Switch>
                    <p
                      className="cursor-pointer text-[14px] font-medium text-black"
                      onClick={() => handleTogglePermission(perm.value)}
                    >
                      {perm.label}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-10 flex justify-end gap-4">
                <button
                  type="button"
                  className="h-[40px] w-[120px] rounded-lg border border-primary bg-white text-[14px] font-medium text-primary transition-all duration-200 hover:bg-primary hover:text-white"
                  onClick={() => dispatch(updateEditActiveStep(2))}
                >
                  Previous
                </button>
                <button
                  className="ease relative h-[40px] w-[120px] rounded-lg border border-primary bg-primary text-[14px] font-medium leading-[38px] text-white transition-all duration-200 hover:bg-none hover:text-primary"
                  onClick={submitForm}
                  type="button"
                  disabled={isSubmitting || !isValid}
                >
                  {isSubmitting ? <ButtonLoader /> : "Update"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EditFeatureAccess;
